import { h, render } from 'preact';
import NoTermResults from './components/no-term-results';
import ResultsList from './components/results-list';
import NullResults from './components/null-results';
import SearchError from './components/search-error';
import PeopleResultsSection from './components/people-results';

export default class Search {
  constructor() {
    this.getReferences();
    if (this.container) {
      this.getSearchData();
      this.init();
    }
  }

  getReferences() {
    this.container = document.getElementById('search-results');
  }

  /**
   * get current search data
   *
   * all of the inital data is set in a script tag in /page-search.php
   */
  getSearchData() {
    this.term = searchTermInit || '';
    this.type = searchTypeInit || '';
    this.people = peopleResults || [];
  }

  init() {
    if (this.type === 'EWU') {
      if (!this.term) {
        this.renderNoTerm();
        return;
      }

      this.performEwuSearch(this.term);
    }
    else if (this.type === 'people') {
      if (!this.term) {
        this.renderNoTerm();
        return;
      }

      this.performPeopleSearch();
    }
    else {
      this.renderError();
    }
  }

  performEwuSearch(query) {
    this.easternData = [];
    this.googleData = [];
    this.renderResults.bind(this)();
  }

  performPeopleSearch() {
    render((<PeopleResultsSection title="People" results={this.people} />), this.container);
  }

  /**
   * render search results
   */
  renderResults() {
    if (!this.easternData.length || !this.googleData.length) {
      this.render
    }

    render(<ResultsList
      term={this.term}
      sections={this.sections}
      type={this.type}
    />, this.container);
  }

  /**
   * Various error endering functions
   */
  renderNoTerm() {
    render(<NoTermResults />, this.container);
  }

  renderError() {
    render(<SearchError />, this.container);
  }

  renderNull() {
    render(<NullResults />, this.container);
  }

  /**
   * validate a response object is in a valid range
   *
   * @param {any} response
   */
  verifyRequest(response) {
    if (response.status >= 200 && response.status < 300) {
      return response.json();
    }

    const error = new Error(response.statusText);
    throw error;
  }

  /**
   * FILTERS
   */

  filterForTerm(result) {
    const regex = new RegExp(this.term, 'gi');
    const { type, longName, description, URL: url } = result;
    const match = longName.match(regex);

    return match && match.length;
  }

  checkType(result, requiredType) {
    const { type } = result;

    if (!type) {
      return false;
    }

    return type === requiredType;
  }
}
